import clsx from "clsx"
import { FC } from "react"
import { useTranslation } from "react-i18next"
import { Outlet, useLocation, useNavigate } from "react-router-dom"
import { ROUTES } from "@/helpers/routes"
import { SHOP_TABS_CONFIG } from "@/pages/Shop/values"
import { Button } from "@/ui/Button"
import styles from "./Shop.module.scss"

export const Shop: FC = () => {
  const { t } = useTranslation()
  const navigate = useNavigate()
  const location = useLocation()

  const handleTab = (path: string) => {
    navigate(path)
  }

  return (
    <div className={clsx(styles.Shop)}>
      <div className={clsx(styles.Shop_title)}>{t("shop.title")}</div>
      <div className={clsx(styles.Shop_inner)}>
        <div className={clsx(styles.Shop_content)}>
          <div className={clsx(styles.Shop_content_header)}>
            <div className={clsx(styles.Shop_nav)}>
              <Button.Back link={ROUTES.HOME} />
              {/* <BalancePill /> */}
            </div>
            <div className={clsx(styles.Shop_content_switcher)}>
              {SHOP_TABS_CONFIG.map(({ key, label, path }) => (
                <div
                  className={clsx(styles.Shop_content_switcher_item, {
                    [styles.active]: location.pathname === path
                  })}
                  onClick={() => handleTab(path)}
                  key={key}
                >
                  {t(label)}
                </div>
              ))}
            </div>
          </div>
          <div className={clsx(styles.Shop_content_body)}>
            <Outlet />
          </div>
        </div>
      </div>
    </div>
  )
}
